<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="vcm-wrapper">

  <!-- Saving overlay -->
  @if (saving()) {
    <div class="vcm-saving-overlay">
      <mat-icon class="vcm-saving-spinner">sync</mat-icon>
      <span>{{ 'ADMIN.medialibrary.videoClips.saving' | translate }}</span>
    </div>
  }

  <!-- Header -->
  <div class="vcm-header">
    <div class="vcm-header-title">   
      {{ 'ADMIN.medialibrary.videoClips.title' | translate }}
    </div>
    <div class="vcm-header-actions">
      @if (selectedCount > 0) {
        <cm-ui-standard-button rounded primary [disabled]="saving()" (onClick)="saveToMediaLibrary()" [icon]="saving() ? '' : 'save'">
          @if (saving()) {
            <mat-icon class="spin-icon">sync</mat-icon>
          }
          {{ 'ADMIN.medialibrary.videoClips.saveSelected' | translate }} ({{ selectedCount }})
        </cm-ui-standard-button>
      }
      <button mat-icon-button (click)="dialogRef.close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Summary -->
  @if (data.result.summary) {
    <div class="vcm-summary">
      <p>{{ data.result.summary }}</p>
    </div>
  }

  <!-- Clips Grid -->
  <div class="vcm-clips-grid">
    @for (highlight of data.result.highlights; track highlight.clip_index) {
      <div class="vcm-clip-card" [class.vcm-clip-selected]="isSelected(highlight.clip_index)">

        <!-- Selection checkbox -->
        @if (!highlight.clip_error) {
          <div class="vcm-clip-checkbox">
            <mat-checkbox
              [checked]="isSelected(highlight.clip_index)"
              (change)="toggleClip(highlight.clip_index)">
            </mat-checkbox>
          </div>
        }

        <!-- Video player -->
        @if (!highlight.clip_error) {
          <video
            class="vcm-video"
            controls
            preload="metadata"
            [src]="mediaUrl(highlight.clip_file)">
          </video>
        } @else {
          <div class="vcm-video-error">
            <mat-icon>videocam_off</mat-icon>
            <small>{{ highlight.clip_error }}</small>
          </div>
        }

        <!-- Clip info -->
        <div class="vcm-clip-info">
          <div class="vcm-clip-topic">{{ highlight.topic }}</div>
          <div class="vcm-clip-time">{{ getHighlightDuration(highlight) }}</div>
          <p class="vcm-clip-reason">{{ highlight.medical_reason }}</p>
        </div>

        <!-- Social media content -->
        @if (highlight.social) {
          <div class="vcm-social">
            <mat-tab-group animationDuration="0">

              <!-- X / Twitter -->
              <mat-tab label="𝕏">
                <div class="vcm-social-tab">
                  @if (highlight.social.thumbnails.length > 0) {
                    <img class="vcm-thumb" [src]="mediaUrl(highlight.social.thumbnails[0].x)" alt="X thumbnail">
                  }
                  <p class="vcm-social-text">{{ highlight.social.social_post.x }}</p>
                  <cm-ui-standard-button rounded (onClick)="copyToClipboard(highlight.social.social_post.x, 'x_' + highlight.clip_index)" icon="content_copy">
                    {{ copiedPlatform() === 'x_' + highlight.clip_index ? ('common.copied' | translate) : ('common.copy' | translate) }}
                  </cm-ui-standard-button>
                </div>
              </mat-tab>

              <!-- Facebook -->
              <mat-tab label="Facebook">
                <div class="vcm-social-tab">
                  @if (highlight.social.thumbnails.length > 0) {
                    <img class="vcm-thumb" [src]="mediaUrl(highlight.social.thumbnails[0].facebook)" alt="Facebook thumbnail">
                  }
                  <p class="vcm-social-text">{{ highlight.social.social_post.facebook }}</p>
                  <cm-ui-standard-button rounded (onClick)="copyToClipboard(highlight.social.social_post.facebook, 'fb_' + highlight.clip_index)" icon="content_copy">
                    {{ copiedPlatform() === 'fb_' + highlight.clip_index ? ('common.copied' | translate) : ('common.copy' | translate) }}
                  </cm-ui-standard-button>
                </div>
              </mat-tab>

              <!-- LinkedIn -->
              <mat-tab label="LinkedIn">
                <div class="vcm-social-tab">
                  @if (highlight.social.thumbnails.length > 0) {
                    <img class="vcm-thumb" [src]="mediaUrl(highlight.social.thumbnails[0].linkedin)" alt="LinkedIn thumbnail">
                  }
                  <p class="vcm-social-text">{{ highlight.social.social_post.linkedin }}</p>
                  <cm-ui-standard-button rounded (onClick)="copyToClipboard(highlight.social.social_post.linkedin, 'li_' + highlight.clip_index)" icon="content_copy">
                    {{ copiedPlatform() === 'li_' + highlight.clip_index ? ('common.copied' | translate) : ('common.copy' | translate) }}
                  </cm-ui-standard-button>
                </div>
              </mat-tab>

            </mat-tab-group>
          </div>
        }

      </div>
    }
  </div>

</div>
